{
  "toast": {
    "experimentCreated": "Experiment créé",
    "winnerDeclared": "Winner declared",
    "marketingCampaignRegistered": "Marketing campagne registered",
    "enrichmentAppliedFromEmailDomain": "Enrichment applied de email domain",
    "formCreatedAndPublishedSuccessfully": "Form créé et published successfully!",
    "formArchived": "Form archived",
    "formPublished": "Formulaire publié",
    "formUnpublished": "Formulaire dépublié",
    "landingPageCreatedPublished": "Landing page créé & published",
    "routingRuleSaved": "Routing rule enregistré",
    "leadScoringRuleSaved": "Lead scoring rule enregistré",
    "sourceCreated": "Source créé",
    "duplicateCandidateResolved": "Candidat doublon résolu"
  },
  "forms": {
    "createAcquisitionForm": "Créer un formulaire d'acquisition",
    "publishImmediately": "Publier immédiatement",
    "visualFieldsSimulation": "Simulation visuelle des champs",
    "remove": "Supprimer",
    "activeFormsList": "Liste des formulaires actifs",
    "publish": "Publier",
    "unpublish": "Dépublier",
    "testPublicView": "Tester la vue publique",
    "embedConfigurations": "Configurations d'intégration",
    "close": "Fermer",
    "defaultFields": {
      "fullName": "Nom complet",
      "emailAddress": "Adresse e-mail",
      "email": "E-mail",
      "phone": "Téléphone"
    },
    "captureTypes": {
      "general": "Général",
      "contactUs": "Contact",
      "demoRequest": "Demande de démo",
      "quoteRequest": "Demande de devis",
      "supportRequest": "Demande de support",
      "newsletterSignup": "Inscription newsletter"
    },
    "fieldTypes": {
      "text": "Champ texte",
      "email": "Adresse e-mail",
      "phone": "Téléphone / mobile",
      "date": "Sélecteur de date",
      "dropdown": "Liste déroulante",
      "checkbox": "Case à cocher",
      "radio": "Boutons radio",
      "multiselect": "Sélection multiple",
      "file": "Téléversement de fichier"
    },
    "status": {
      "published": "Publié",
      "draft": "Brouillon"
    },
    "submit": "Soumettre"
  },
  "breadcrumbs": {
    "leadGen": "Génération de leads",
    "campaigns": "Campagnes",
    "landingPages": "Pages d'atterrissage",
    "scoringRules": "Règles de notation",
    "sources": "Sources",
    "consent": "Consentement",
    "enrichment": "Enrichissement",
    "leadRouting": "Routage des leads"
  },
  "errors": {
    "nameAndSlugRequired": "Name et slug requis",
    "failedToLoadExperiments": "Échec du chargement de experiments",
    "failedToLoadLandingPages": "Échec du chargement de landing pages",
    "createFailed": "Échec de la création",
    "failedToDeclareWinner": "Échec : declare winner",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "failedToLoadConsentLogs": "Échec du chargement de consent logs",
    "crmLeadIdAndEmailRequired": "CRM lead ID et email requis",
    "noEnrichmentForThisLeadYet": "No enrichment pour ce lead yet",
    "enrichmentFailed": "Échec de enrichment",
    "failedToLoadForms": "Échec du chargement de forms",
    "failedToCreateForm": "Échec de la création de form",
    "failedToUpdateForm": "Échec de la mise à jour de form",
    "failedToDeleteForm": "Échec : delete form",
    "failedToCreateLandingPage": "Échec de la création de landing page",
    "formNotFound": "Form pas found",
    "submissionFailed": "Échec de la soumission",
    "validationFailed": "Échec de la validation",
    "missingRequiredField": "Champ obligatoire manquant : {{field}}",
    "failedToLoadReports": "Échec du chargement de reports",
    "failedToLoadRoutingRequirements": "Échec du chargement de routing requirements",
    "failedToCreateRoutingRule": "Échec de la création de routing rule",
    "failedToLoadScoringRules": "Échec du chargement de scoring rules",
    "failedToCreateScoringRule": "Échec de la création de scoring rule",
    "failedToLoadSources": "Échec du chargement de sources",
    "failedToCreateSource": "Échec de la création de source",
    "failedToLoadVisitorProfiles": "Échec du chargement de visitor profiles",
    "failedToLoadDashboard": "Échec du chargement du tableau de bord",
    "failedToResolveDuplicateCandidate": "Échec de la résolution du candidat doublon"
  },
  "reports": {
    "breadcrumb": "Rapports",
    "summaryTitle": "Vue d'ensemble",
    "refresh": "Actualiser",
    "refreshing": "Actualisation…",
    "retry": "Réessayer",
    "loading": "Chargement des rapports…",
    "averageScoreLabel": "Score moyen : {{score}} pts",
    "gradeCount": "{{count}} prospects",
    "summary": {
      "totalLeads": "Total des leads",
      "conversionRate": "Taux de conversion",
      "convertedCount": "{{count}} convertis",
      "avgLeadScore": "Score moyen",
      "overallRoi": "ROI global",
      "spendRevenue": "Dépenses {{spend}} · Revenus {{revenue}}",
      "formSubmissions": "Soumissions de formulaire",
      "activeCampaigns": "Campagnes actives",
      "totalSpend": "Dépenses campagnes"
    },
    "columns": {
      "source": "Origine",
      "leads": "Prospects",
      "converted": "Convertis",
      "conversionRate": "Taux de conversion",
      "share": "Part",
      "campaign": "Campagne",
      "channel": "Canal",
      "budget": "Budget",
      "cost": "Coût",
      "utmCampaign": "Campagne UTM",
      "status": "Statut",
      "eventType": "Type d'événement",
      "count": "Nombre",
      "utmSource": "Source UTM",
      "model": "Modèle",
      "attributedLeads": "Leads attribués",
      "leadCost": "Coût par lead",
      "revenue": "Revenus attribués",
      "roi": "ROI"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "eventTypes": {
      "FORM_SUBMISSION": "Soumission de formulaire",
      "PAGE_VIEW": "Vue de page",
      "CLICK": "Clic",
      "CONVERSION": "Conversion",
      "LEAD_CREATED": "Lead créé"
    },
    "empty": {
      "leadSource": "Aucune donnée de source",
      "leadSourceHint": "Capturez des leads via formulaires ou imports pour voir la répartition.",
      "conversion": "Aucun événement de conversion",
      "conversionHint": "L'activité visiteurs et formulaires apparaîtra ici.",
      "campaign": "Aucune campagne configurée",
      "campaignHint": "Ajoutez des campagnes pour suivre dépenses, UTM et ROI.",
      "attribution": "Aucune donnée d'attribution",
      "attributionHint": "L'attribution multi-touch apparaît quand les leads ont des points UTM.",
      "roi": "Aucune donnée ROI",
      "roiHint": "Renseignez coût et revenus des campagnes pour calculer le ROI."
    }
  },
  "duplicates": {
    "title": "Revue des doublons",
    "description": "Passez en revue les candidats leads en doublon créés par les règles de détection configurables.",
    "breadcrumbs": {
      "leadGen": "Génération de leads",
      "duplicates": "Doublons"
    },
    "columns": {
      "candidate": "Candidat #",
      "submission": "Soumission",
      "incomingLead": "Lead entrant",
      "matchedLead": "Lead correspondant",
      "matchedFields": "Champs correspondants",
      "suggestedAction": "Action suggérée",
      "actions": "Opérations"
    },
    "actions": {
      "updateExisting": "Mettre à jour l'existant",
      "ignore": "Ignorer",
      "merge": "Fusionner"
    },
    "empty": {
      "title": "Aucun candidat doublon",
      "description": "Les nouveaux candidats doublons apparaîtront ici pour revue."
    }
  },
  "campaigns": {
    "sections": {
      "registerAcquisitionCampaign": "Enregistrer une campagne d'acquisition",
      "attributionsOverview": "Vue d'ensemble des attributions"
    },
    "attributionModels": {
      "first": "Premier contact (crédit complet au clic initial)",
      "last": "Dernier contact (crédit complet à la page de conversion)",
      "multi": "Multi-touch (répartition pondérée entre les points de contact)"
    },
    "channelLabel": "Canal : {{channel}}",
    "roiLabel": "ROI : {{roi}}",
    "metrics": {
      "budget": "Budget",
      "cost": "Coût",
      "revenue": "Revenu"
    }
  },
  "pages": {
    "aBLandingTests": "A/B landing tests",
    "trafficSplitExperimentsAcrossLandingPage": "Traffic-split experiments across landing page variants",
    "marketingCampaignsRoi": "Marketing Campagnes & ROI",
    "linkAdvertisingCostsUtmParametersAnd": "Link advertising costs, UTM parameters, et multi-touch revenue attribution modeling.",
    "gdprConsentTracking": "GDPR & Consent Tracking",
    "configurePrivacyBannersTrackPolicyConsent": "Configure privacy banners, track policy consent versions, et audit utiliserr acceptance logs.",
    "leadGenDashboard": "Tableau de bord",
    "additionalMetrics": "Indicateurs supplémentaires",
    "totalVisitors": "Total visitors",
    "conversions": "Conversions",
    "avgLeadScore": "Avg. prospect score",
    "inboundAcquisitionFunnel": "Inbound acquisition funnel",
    "leadScoreDistribution": "Prospect score distribution",
    "campaignRoi": "Campagne ROI",
    "visitorTrackingFormsScoringAndCrm": "Visitor tracking, forms, scoring, et CRM conversion in votre scope",
    "topLeadSources": "Top prospect sources",
    "noLeadSourceData": "Aucune source de leads pour le moment",
    "noFunnelData": "Aucune activité d'entonnoir pour cette période",
    "noScoreData": "Aucun lead noté pour le moment",
    "noCampaignData": "Aucune campagne pour le moment",
    "createSource": "Ajouter une source",
    "createCampaign": "Créer une campagne",
    "leadsCount": "{{count}} prospects",
    "shareLabel": "Part : {{share}}",
    "scorePoints": "{{score}} pts",
    "visitorsTrend": "CVR {{rate}}% · {{submissions}} soumissions",
    "roiPercent": "{{value}}% ROI",
    "quickLinkForms": "Gérer les formulaires",
    "quickLinkCampaigns": "Voir les campagnes",
    "quickLinkReports": "Ouvrir les rapports",
    "leadEnrichment": "Prospect enrichment",
    "domainInferenceAndFirmographicHintsRuns": "Domain inference et firmographic hints — runs automatically on form submit; manual refresh here",
    "acquisitionLeadForms": "Acquisition Prospect Forms",
    "visualFormBuilderAndSecureEmbedding": "Visual Form Builder et secure embedding configurations.",
    "landingPageBuilder": "Landing Page Builder",
    "launchHighConvertingLandingPagesWith": "Launch high-converting landing pages avec native A/B testing et custom domain support.",
    "leadGenReports": "Lead Gen Rapports",
    "leadSourceReport": "Lead Source Rapport",
    "campaignReport": "Campaign Rapport",
    "conversionReport": "Conversion Rapport",
    "scoringReport": "Scoring Rapport",
    "attributionReport": "Attribution Rapport",
    "roiReport": "ROI Rapport",
    "leadSourceCampaignConversionScoringAttribution": "Lead source, campaign, conversion, scoring, attribution, et ROI analytics.",
    "leadRoutingTerritories": "Prospect Routing & Territories",
    "configureAutomatedAssignmentCriteriaByCountry": "Configure automated assignment criteria by country, region, state, ou produit, avec integrated round-robin distribution.",
    "leadScoringGrading": "Prospect Scoring & Grading",
    "establishScoringThresholdsAndAssignQuality": "Establish scoring thresholds et assign quality grades (A+, A, B, C, D) based on visitor events et profiles.",
    "leadSources": "Prospect Sources",
    "acquisitionChannelCatalogWebsiteAdsSocial": "Acquisition channel catalog — website, ads, social, partner portal, et API imports.",
    "visitorSessionTracking": "Visitor Session Tracking",
    "monitorAnonymousVisitorPathsReferrersAnd": "Monitor anonymous visitor paths, referrers, et cookie IDs prior à lead conversion.",
    "leadAdWebhooks": "Prospect ad webhooks",
    "facebookAndGoogleLeadAdsPost": "Facebook et Google Lead Ads POST into LeadIntakeService — same path as form submissions"
  },
  "landingPages": {
    "sections": {
      "createLandingPage": "Créer une page d'atterrissage",
      "activeLandingPages": "Pages d'atterrissage actives"
    },
    "variants": {
      "a": "Variante A (mise en page par défaut)",
      "b": "Variante B (formulaire interactif latéral)",
      "c": "Variante C (texte minimaliste uniquement)"
    },
    "templates": {
      "demo": "Inscription à une démo produit interactive",
      "newsletter": "Panneau d'inscription à la newsletter",
      "quote": "Estimateur finance et devis"
    },
    "versionLabel": "Version {{version}}",
    "variantLabel": "Variante {{variant}}",
    "metrics": {
      "views": "Vues",
      "conversions": "Conversions"
    }
  },
  "scoring": {
    "sections": {
      "defineLeadScoringRule": "Définir une règle de notation des leads",
      "gradingThresholdMatrix": "Matrice des seuils de notation",
      "configuredRules": "Règles configurées"
    },
    "triggerEvents": {
      "formSubmission": "Lors de la soumission d'un formulaire",
      "pageView": "Lors de la vue d'une page d'atterrissage",
      "emailOpen": "Lors de l'ouverture d'un e-mail de campagne",
      "download": "Lors du téléchargement d'un livre blanc ou document",
      "leadCreated": "Lors de la création d'un lead entrant"
    },
    "pointsRange": "{{range}} points",
    "ruleDeltaLabel": "Delta : {{delta}} sur {{eventType}}",
    "status": {
      "active": "Actif"
    },
    "empty": {
      "noGradeConfig": "Aucune configuration de note reçue du serveur — vérifiez la fonctionnalité LEAD_GEN_SCORING."
    }
  },
  "empty": {
    "noExperimentsYet": "Aucune expérience pour le moment"
  },
  "publicSubmit": {
    "thankYou": "Merci",
    "requestReceived": "Nous avons bien reçu votre demande et vous recontacterons bientôt.",
    "contactUs": "Contactez-nous",
    "gdprConsent": "J'accepte le traitement de mes données (RGPD)"
  },
  "dialogs": {
    "declareWinner": "Déclarer le gagnant"
  },
  "labels": {
    "experimentName": "Experiment name",
    "slug": "Slug",
    "variantPageIdsComma": "Variant page IDs (comma)",
    "trafficWeights": "Traffic weights",
    "campaignName": "Campagne Name",
    "adPlatformChannel": "Ad Platform / Canal",
    "allocatedBudgetInr": "Allocated Budget (INR)",
    "actualCostInr": "Actual Cost (INR)",
    "revenueAttributedInr": "Revenue Attributed (INR)",
    "attributionModel": "Attribution Model",
    "eGQ2EnterpriseCloudPromo": "e.g. Q2 Saisirprise Cloud Promo",
    "eGLinkedinAds": "e.g. LinkedIn Ads",
    "bannerTextCookieConsent": "Banner Text (Cookie Consent)",
    "privacyStatementForms": "Privacy Statement (Forms)",
    "crmLeadId": "prospect CRM ID",
    "emailForDomainEnrich": "Email (for domain enrich)",
    "formName": "Form Name",
    "description": "Descriptif",
    "captureType": "Capture Type",
    "fieldLabel": "Field Label",
    "fieldType": "Field Type",
    "optionsCommaSeparated": "Options (Comma separated)",
    "eGInboundDemoRequest": "e.g. Inbound Demo Request",
    "optionalInternalDescription": "Facultatif internal description...",
    "eGOrganizationName": "e.g. Organization Name",
    "eGSmallMediumEnterprise": "e.g. Small, Medium, Saisirprise",
    "pageTitle": "Page Title",
    "urlSlug": "URL Slug",
    "customDomain": "Custom Domain",
    "aBVariant": "A/B Variant",
    "landingPageTemplate": "Landing Page Template",
    "eGFreeEnterpriseAuditTrial": "e.g. Free Saisirprise Audit Trial",
    "eGEnterpriseAudit": "e.g. saisirprise-audit",
    "eGPromoMycompanyCom": "e.g. promo.mycompany.com",
    "ruleName": "Règle Name",
    "priorityOrder": "Priority Order",
    "assignToEmployee": "Assign à employé",
    "teamQueueCodeOptional": "Équipe / Queue Code (Facultatif)",
    "crmTerritoryOptional": "CRM territory (facultatif)",
    "eGIndiaRegionRouting": "e.g. India Region Routing",
    "leaveBlankForRoundRobinQueue": "Congé blank pour round-robin queue",
    "eGInSalesTeam": "e.g. IN_SALES_TEAM",
    "none": "— Aucun —",
    "scoreDeltaPoints": "Score Delta (Points)",
    "triggerEvent": "Trigger Event",
    "eGEnterpriseIndustryMatch": "e.g. Saisirprise Industry Match",
    "eG15Or10": "e.g. 15 ou -10",
    "code": "Code",
    "name": "Nom",
    "sourceType": "Type de source",
    "partnerXReferrals": "Partner X Referrals",
    "winnerLandingPageId": "ID de la page d'atterrissage gagnante",
    "webhookSecret": "Secret webhook",
    "optionalEnforcedInSecurityPhase": "Facultatif, appliqué durant la phase de sécurité"
  },
  "sources": {
    "configuredSources": "Sources configurées",
    "addCustomSource": "Ajouter une source personnalisée"
  },
  "formActions": {
    "saveRoutingPolicy": "Enregistrer la politique de routage",
    "saveCampaign": "Enregistrer la campagne",
    "addSource": "Ajouter une source",
    "saveScoringRule": "Enregistrer la règle de notation",
    "addField": "Ajouter un champ",
    "saveAndPublishForm": "Enregistrer et publier le formulaire"
  },
  "listActions": {
    "createExperiment": "Créer une expérience",
    "getEmbedCode": "Obtenir le code d'intégration",
    "publishLandingPage": "Publier la page d'atterrissage"
  }
}
